import React, { useState } from 'react';
import './styles.scss';

const NoticeModal = () => {
  const [noticeModal, setNoticeModal] = useState({
    hideModal: true,
    header: 'Notice',
    message: 'Message',
    attention: false,
    error: false,
  });

  const classList = ['profile-notice'];

  if (noticeModal.hideModal) {
    classList.push('hidden');
  }

  if (noticeModal.error) {
    classList.push('error');
  }

  if (noticeModal.attention) {
    classList.push('attention');
  }

  function toggleModal() {
    setNoticeModal({ ...noticeModal, hideModal: !noticeModal.hideModal });
  }

  function updateNotice(options, timeout = 0) {
    setNoticeModal({
      ...noticeModal,
      ...options,
      hideModal: false,
    });

    if (timeout) {
      setTimeout(() => {
        setNoticeModal({
          ...noticeModal,
          hideModal: true,
          error: false,
        });
      }, timeout);
    }
  }

  window.updateNotice = updateNotice;

  return (
    <div className={classList.join(' ')}>
      <div className="component">
        <div className="notice-header">
          <div className="header-title">
            <h1 className="header-title-header">{noticeModal.header}</h1>
            <p className="header-title-subheader">
              {noticeModal.message}
            </p>
          </div>
          <button
            type="button"
            className="profile-edit-button close"
            onClick={toggleModal}
          >
            <i className="times" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default NoticeModal;
